import { createEffect } from 'effector';
import {
    traderPayoutTraderServiceBalance,
    traderPayoutTraderServiceGetMe,
    traderPayoutTraderServiceRegister,
    traderPayoutTraderServiceSetWorkingStatus,
} from '~/generated/payoutBackend/trader';

export const getBalanceFx = createEffect(traderPayoutTraderServiceBalance);
export const getMeTraderFx = createEffect(async () => {
    return await traderPayoutTraderServiceGetMe({
        context: {
            skipErrorNotification: true,
        },
    });
});
export const verifyTraderFx = createEffect(traderPayoutTraderServiceRegister);
export const updateWorkingStatusFx = createEffect(traderPayoutTraderServiceSetWorkingStatus);
